export default __webpack_public_path__ + "static/media/email.66a6ec2e.svg";